import { ModalProps } from 'src/modals/Modal';
import { SellerRoleInfo } from 'src/WebApiController';

export const MAX_ROLE_DETAILS_LENGTH = 200;

export type SellerRoleModalProps = {
  cancelTo?: ModalProps;
  roleInfo?: SellerRoleInfo | null;
};
